import axios from "@/plugins/axios";

let url = (data = { _program: undefined }) => "/api/v1/programs/${_program}/categories".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};
